import { DeleteUploadedTableDocument } from "src/gql/codegen/graphql";
import { pick } from "lodash";
import { useSession } from "src/components/session/session";
import { useActiveContext } from "shared/ContextSwitcher/store";
import { apolloCore } from "src/utils/apollo/apollo";
import { callUploadedTables } from "../useUploadedTables";
import { addToastNotification } from "shared/Toasts/toastNotificationStore";
import { useState } from "react";
import { gql } from "@apollo/client";

export const useDeleteDataset = ({
  tableName,
  onComplete,
}: {
  tableName: string;
  onComplete: () => void;
}) => {
  const session = useSession();
  const activeContext = useActiveContext();
  const [catalog, schema, name] = tableName.split(".");
  const [isLoading, setIsLoading] = useState(false);

  return {
    onDelete: () => {
      if (!catalog || !schema || !name || !activeContext || !session) {
        return;
      }

      setIsLoading(true);

      return apolloCore
        .mutate({
          context: {
            session,
          },
          mutation: DeleteUploadedTableDocument,
          variables: {
            catalog,
            schema,
            name,
            contextOwner: pick(activeContext, ["id", "type"]),
          },
        })
        .then(() => {
          callUploadedTables(session, activeContext);
        })
        .catch((error) => {
          addToastNotification({
            level: "error",
            title: "Failed to delete dataset",
            description: error.message,
          });
        })
        .finally(() => {
          setIsLoading(false);
          onComplete();
        });
    },
    isLoading,
  };
};

gql`
  mutation DeleteUploadedTable(
    $catalog: String!
    $schema: String!
    $name: String!
    $contextOwner: ContextOwner!
  ) {
    delete_uploaded_table(
      catalog: $catalog
      schema: $schema
      name: $name
      context_owner: $contextOwner
    ) {
      id
    }
  }
`;
